// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2kwjY","signatureBlock":"Footer_signatureBlock__2tLuO","signature":"Footer_signature__dsTgl"};